let wrapper=(val)=>val.toString().length<2?"0"+val:""+val;

export let getDuration=(time)=>{
    if(isNaN(Number(time)))throw new Error("Invalid Time difference in dateSupport.js at line 4.");
    time=Number(time);
    let ss = parseInt(time % 60)
    let mm = parseInt((time / 60) % 60)
    let hh = parseInt((time / (60 * 60)) % 24);

    return `${hh?wrapper(hh)+':':''}${wrapper(mm)}:${wrapper(ss)}`;
}